<table>
    <thead>
      <tr>
        <th class="subtable id">{{'mantenimientoEtiquetadores.almacen.id' | translate}}</th>
        <th class="subtable string">{{'global.almacen' | translate}}</th>
        <th class="subtable string">{{'mantenimientoEtiquetadores.almacen.direccion' | translate}}</th>
        <th class="subtable string">{{'global.pais' | translate}}</th>
        <th class="subtable string">{{'global.provincia' | translate}}</th>
        <th class="subtable string">{{'global.municipio' | translate}}</th>
        <th class="subtable string">{{'mantenimientoEtiquetadores.almacen.zona' | translate}}</th>
        <th class="subtable string">{{'mantenimientoEtiquetadores.almacen.gps' | translate}}</th>
        <th class="subtable action">
          <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="new=true;almacenEditable=''"
              title="{{'mantenimientoEtiquetadores.almacen.tituloNew' | translate}}"></i>
        </th>
      </tr>
    </thead>
    <tbody>
        <app-etq-almacen-new-edit class="component-in-row" *ngIf="new" [editable]="true" [etiquetadorId]="etiquetadorId" (close)="new=$event"
        (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"
        (pushMessage)="pushMessage.emit($event)"></app-etq-almacen-new-edit>
        <app-etq-almacen-new-edit class="component-in-row" *ngFor="let almacen of almacenesList" [etiquetadorId]="etiquetadorId" [almacen]="almacen" [editable]="almacen === almacenEditable" (close)="new=$event"
        (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"
        (pushMessage)="pushMessage.emit($event)"></app-etq-almacen-new-edit>
    </tbody>
    <tfoot *ngIf="almacenesList && almacenesList.length < 1 && !new">
      <tr>
        <td colspan="10">
          {{'global.noContent' | translate}}
        </td>
      </tr>
    </tfoot>
</table>
